import { accountPagePlayersModel } from 'pages/account-page/model';
import { createPlayerRegistry } from 'entities/player';
import cls from './account-page-players.module.scss';

const PlayerRegistry = createPlayerRegistry(accountPagePlayersModel.playerRegistryModel);

export const AccountPagePlayers = () => (
	<PlayerRegistry
		withTitle={false}
		withAccount={false}
		className={cls.accountPagePlayersRegistry}
	/>
);
